"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OidcAccessToken = require("./OidcAccessToken");
Object.keys(_OidcAccessToken).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OidcAccessToken[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OidcAccessToken[key];
    }
  });
});
var _OidcIdToken = require("./OidcIdToken");
Object.keys(_OidcIdToken).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OidcIdToken[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OidcIdToken[key];
    }
  });
});
var _OidcToken = require("./OidcToken");
Object.keys(_OidcToken).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OidcToken[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OidcToken[key];
    }
  });
});
var _Token = require("./Token");
Object.keys(_Token).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Token[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Token[key];
    }
  });
});
var _TokenData = require("./TokenData");
Object.keys(_TokenData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TokenData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TokenData[key];
    }
  });
});
//# sourceMappingURL=index.js.map